import {filter, map} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';
type TradeMsg = ws.TradeMsg;

export const tradeMsg$ = wsMsg$.pipe(
  filter((o: TradeMsg) => !!o.trades || !!o.trades_p),
  map((trade) => {
    const {trades_p, trades, ...data} = trade;
    return {...data, trades: trades ? trades : convertTrades(trades_p)};
  })
);

function convertTrades(trades) {
  return trades.map(([t, side, price, size]) => [t, side, Number(price), Number(size)]);
}
